import type { ShipmentEmbryo } from '@/services/shipping/types';

import { highlightColors } from './constants';

type ComboKey = string;

const getComboKey = (embryo: ShipmentEmbryo | null | undefined): ComboKey => {
  if (!embryo) return '';

  const mating = embryo.name || '';
  const cane = embryo.cane || '';
  const freezeDate = embryo.creation
    ? new Date(embryo.creation).toISOString().split('T')[0]
    : '';

  return `${mating}|${cane}|${freezeDate}`;
};

export const getCaneHighlightColor = (
  embryo: ShipmentEmbryo | null | undefined,
  allEmbryos: (ShipmentEmbryo | null | undefined)[],
  multipleCanesEmbryoIds?: string[],
): string => {
  if (!embryo || !allEmbryos || allEmbryos.length === 0) {
    return '';
  }

  const embryoId = embryo.id;
  if (
    !embryoId ||
    !multipleCanesEmbryoIds ||
    !multipleCanesEmbryoIds.includes(embryoId)
  ) {
    return '';
  }

  const filteredEmbryos = allEmbryos.filter(
    (emb) => emb && multipleCanesEmbryoIds.includes(emb.id),
  );

  const comboMap = new Map<ComboKey, number>();
  let colorIndex = 0;

  filteredEmbryos.forEach((emb) => {
    if (!emb) return;
    const key = getComboKey(emb);
    if (key && !comboMap.has(key)) {
      comboMap.set(key, colorIndex);
      colorIndex = (colorIndex + 1) % highlightColors.length;
    }
  });

  const embryoKey = getComboKey(embryo);
  const assignedIndex = comboMap.get(embryoKey);

  if (assignedIndex === undefined) {
    return '';
  }

  return highlightColors[assignedIndex];
};
